/**
 * Portal Manta · PluviChart
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { S, V } from '../../globals.js';
import { F } from '../../tokens/fonts.js';
import { M } from '../../tokens/colors.js';

function PluviChart({mensal}){
  const max = Math.max(...mensal);
  const meses = ['J','F','M','A','M','J','J','A','S','O','N','D'];
  return (<div>
    <div style={{display:'flex',alignItems:'flex-end',gap:3,height:90}}>
      {mensal.map((v,i)=>(<div key={i} style={{flex:1,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'flex-end'}}>
        <div title={`${meses[i]}: ${v} mm`} style={{width:'100%',height:`${v/max*72}px`,background:`linear-gradient(180deg, ${V.bl}, ${V.br2})`,borderRadius:'3px 3px 0 0',position:'relative'}}>
          <div style={{position:'absolute',top:-13,left:'50%',transform:'translateX(-50%)',fontSize:8,color:V.g5,fontWeight:600}}>{v}</div>
        </div>
        <div style={{fontSize:9,color:V.g4,marginTop:3}}>{meses[i]}</div>
      </div>))}
    </div>
  </div>);
}

export { PluviChart };
export default PluviChart;
